var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[(_vm.isLoading)?_c('button',{staticClass:"btn btn-info"},[_vm._v("Loading...")]):_c('button',{class:_vm.myClass ? _vm.myClass : 'btn btn-info btn-anim',on:{"click":function($event){return _vm.$emit('submit')}}},[_c('i',{staticClass:"icon-rocket"}),_c('span',{staticClass:"btn-text"},[_vm._v(_vm._s(_vm.text))])])])
}
var staticRenderFns = []

export { render, staticRenderFns }